export const TEMPLATE_IDS = [
  // FANS
  "A1",
  "A1a",
  "A2",
  "A3",
  "A3a",
  "A4",
  "B1",
  "B2",
  "B3",
  "B4",
  "B5",
  "B7",
  "C1",
  "C2",
  "D1",
  "D1x",
  "E1",
  "F2",
  "G1",
  "J1",
  "L1",
  "L2",
  "M1",
  "N1",
  "O1",
  "RCF103",
  "RCF104",
  "RCF111v2",
  "RCF118",
  "RCF119v2",
  "RCF124",
  "RCF132",
  "RCF137",
  "RCF138",
  "RCF140v2",
  "RCF142",
  "RCF143",
  "RCF144",
  "RCF161",
  "RCF165",
  "RCF181",
  "RCF188",
  "RCF84",
  "RCF87",
  "RCF94v2",
  "RCF98v2",
  "RCF999",
  // SHADES
  "RMS12",
  // FIREPLACE
  "RFP10",
  "RFP12",
  "RFP23",
  "RFP4",
  "RFP48",
  "RFP5",
  "RFP7",
  "RFP8",
];
